export default "__VITE_ASSET__DvhOU6iP__"